"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const validate_1 = require("../../../app/dist/validate");
exports.toolDef = {
    name: 'loom_validate',
    description: 'Validate Loom docs and return structured per-weave issues (broken parent_id, dangling child_id, stale plans, missing Steps tables, step-blocker cycles). Pass weave_slug for a single weave, or all=true for every weave. Pure read — no mutations.',
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Validate a single weave' },
            all: { type: 'boolean', description: 'Validate every weave (used when weave_slug is omitted)' },
        },
        required: [],
    },
};
async function handle(root, args) {
    const weaveSlug = args['weave_slug'];
    // Only the structured `results` are returned — never the LinkIndex (functions/maps).
    const { results } = await (0, validate_1.validate)({ weaveSlug, all: !weaveSlug }, { getActiveLoomRoot: dist_1.getActiveLoomRoot, buildLinkIndex: dist_1.buildLinkIndex, loadDoc: dist_1.loadDoc, fs, loomRoot: root });
    return { content: [{ type: 'text', text: JSON.stringify({ results }) }] };
}
